import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PharmacySearchComponent } from './components/pharmacy-search/pharmacy-search.component';
import { AuthGuard, FeatureGuard } from 'src/app/guards';
import { NoAccessComponent } from 'src/app/components/no-access/no-access.component';
const routes: Routes = [
  {
    path: 'pharmacy',
    component: PharmacySearchComponent,
    canActivate: [AuthGuard, FeatureGuard],
    data: {feature: 'UI::PharmacyList'}
  },
  {
    path: 'no-access',
    component: NoAccessComponent,
  }
  
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PharmacyRoutingModule { }
